// import React from "react";
import styles from "./Spinner.module.css";
// import spinnerSvg from "./3.svg";

const spinnerSvg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve">
<g id="_x31_2">
	<path style="fill:#FFB531;" d="M65.17,29.459c-17.747,1.083-31.247,16.34-30.165,34.075c0.578,9.529,5.246,17.832,12.177,23.306
		c5.992,4.741,13.681,7.364,21.898,6.87c0,0-0.036-1.745-0.036-4.536l-6.497-7.099c0,0-1.384-2.635-1.684-7.689
		c-2.984-0.758-5.21-3.477-5.21-6.69c0-3.802,3.092-6.894,6.894-6.894c2.539,0,4.765,1.372,5.956,3.417
		c0.481,0.217,0.975,0.433,1.48,0.638c0.481-5.017,1.191-9.493,2.25-12.225c3.718-9.638,17.964-13.5,17.964-13.5
		C83.892,32.659,74.904,28.869,65.17,29.459z"/>
	<g>
		<path style="fill:#374650;" d="M113.548,72.201c-0.431-1.468-1.7-2.445-3.232-2.488c-1.004-0.029-2.133-0.074-3.313-0.127
			c-2.09-7.262-7.582-26.874-7.91-30.101l-0.165-1.623h-1.631c-0.094,0-2.251,0.012-5.354,0.513
			c-0.246-0.275-0.431-0.472-0.455-0.498c-6.558-6.732-15.564-10.425-24.902-10.273L83.327,9.348l-1.624-1.189
			C74.408,2.821,65.76,0,56.695,0C33.321,0,14.305,19.015,14.305,42.389c0,5.44,1.016,10.738,3.022,15.748l0.971,2.425l11.41-10.467
			l0.078-0.667c0.06-0.511,0.145-1.016,0.242-1.531c2.499-13.077,15.181-21.68,28.261-19.182c0.032,0.006,0.062,0.016,0.093,0.023
			c-15.308,4.071-26.18,18.506-25.181,34.913c0.513,8.415,4.149,16.314,10.105,22.173l-7.012,22.934L84.404,128v-19.396l5.24,5.717
			l0.819-3.244c0.062-0.243,6.339-24.512,21.704-35.019C113.439,75.189,113.981,73.676,113.548,72.201z M103.19,69.371
			c-1.845-0.123-3.606-0.263-5.322-0.425c-10.898-1.018-20.052-2.93-26.679-5.551l0.062,0.002
			c0.159-5.387,2.513-18.257,20.874-21.396h0.002c1.481-0.255,2.751-0.387,3.662-0.456C96.999,47.475,101.45,63.265,103.19,69.371z
			 M26.481,47.22c-0.071,0.374-0.135,0.741-0.19,1.109l-6.513,5.975c-1.238-3.834-1.864-7.83-1.864-11.916
			c0-21.383,17.397-38.779,38.78-38.779c7.617,0,14.91,2.176,21.218,6.313L62.986,26.256c-1.278-0.456-2.625-0.821-4.019-1.088
			C43.926,22.296,29.355,32.186,26.481,47.22z M65.279,31.259c8.305-0.502,16.429,2.417,22.494,8.04
			c-6.922,1.958-18.326,7.324-19.941,21.491c-1.497-1.143-3.352-1.796-5.289-1.796c-4.792,0-8.692,3.907-8.692,8.708
			c0,3.54,2.133,6.66,5.319,8.004c0.453,4.589,1.715,7.098,1.773,7.21l0.109,0.209l8.037,8.77c-0.038,0.003-0.077,0.007-0.115,0.01
			c-7.46,0.45-14.808-1.844-20.671-6.478c-6.783-5.358-10.974-13.375-11.5-21.996C35.785,46.71,48.559,32.278,65.279,31.259z
			 M62.543,72.785c-0.435,0-0.842-0.048-1.237-0.147c-2.264-0.572-3.845-2.601-3.845-4.936c0-2.812,2.28-5.098,5.082-5.098
			c1.808,0,3.495,0.969,4.409,2.539c0.458,0.776,0.69,1.637,0.69,2.559C67.642,70.504,65.355,72.785,62.543,72.785z M80.795,122.668
			l-40.077-16.031l5.57-18.218c5.974,4.643,13.285,7.15,20.839,7.15c0.696,0,1.394-0.021,2.093-0.063
			c0.598-0.045,1.774-0.161,2.806-0.409l8.77,9.569V122.668z M87.879,107.055L64.062,81.068c-0.225-0.519-0.832-2.121-1.186-4.69
			c4.647-0.177,8.375-3.995,8.375-8.676c0-0.149-0.021-0.292-0.028-0.439c6.821,2.504,15.633,4.28,26.306,5.276
			c2.531,0.24,5.147,0.434,8.005,0.593c1.544,0.08,2.974,0.136,4.262,0.176C96.807,82.411,90.154,99.897,87.879,107.055z"/>
		
			<rect x="71.018" y="77.169" transform="matrix(0.4582 -0.8888 0.8888 0.4582 -28.4016 110.1471)" style="fill:#374650;" width="10.274" height="2.406"/>
		
			<rect x="75.147" y="81.222" transform="matrix(0.5173 -0.8558 0.8558 0.5173 -30.4257 110.9082)" style="fill:#374650;" width="15.916" height="2.407"/>
		
			<rect x="78.99" y="84.377" transform="matrix(0.5174 -0.8557 0.8557 0.5174 -29.8271 118.2687)" style="fill:#374650;" width="21.917" height="2.407"/>
		<path style="fill:#374650;" d="M19.686,45.507l2.404-0.115c-0.801-16.679,9.647-30.991,25.998-35.613l-0.654-2.315
			C30.254,12.319,18.844,27.963,19.686,45.507z"/>
		<path style="fill:#374650;" d="M52.483,6.377l0.357,2.381c1.294-0.194,2.622-0.324,3.948-0.388l-0.115-2.404
			C55.266,6.033,53.857,6.171,52.483,6.377z"/>
	</g>
</g>
<g id="Layer_1">
</g>
</svg>`;

const spinnerAsset = (svg) => `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

/**
 * Loading spinner using an external SVG file and CSS Modules.
 *
 * Props:
 * - size: number|string (px by default) — width/height of spinner (default 24)
 * - speed: string — CSS time for one rotation (default "0.8s")
 * - label: string — accessible label for screen readers (default "Loading…")
 * - color: string — e.g. "#4f46e5" or "currentColor" (masked mode uses this to tint)
 * - variant: "img" | "mask" — use <img> or CSS mask (default "img")
 * - className: string — optional extra class on the wrapper
 * - children: ReactNode — optional text to show to the right of the spinner
 */
export default function Spinner({
  size = 72,
  speed = "1.5s",
  label = "Loading…",
  color,
  variant = "img",
  className,
  children,
  ...rest
}) {
  const dim = typeof size === "number" ? `${size}px` : size;

  const commonStyle = {
    width: dim,
    height: dim,
    animationDuration: speed,
  };

  return (
    <span
      className={[styles.root, className].filter(Boolean).join(" ")}
      role="status"
      aria-live="polite"
      {...rest}
    >
      {variant === "mask" ? (
        <span
          className={[styles.icon, styles.spin, styles.masked].join(" ")}
          style={{
            ...commonStyle,
            backgroundColor: color || "currentColor",
            WebkitMaskImage: `url(${spinnerAsset(spinnerSvg)})`,
            maskImage: `url(${spinnerAsset(spinnerSvg)})`,
          }}
          aria-hidden="true"
        />
      ) : (
        <img
          src={spinnerAsset(spinnerSvg)}
          alt=""
          className={[styles.icon, styles.spin].join(" ")}
          style={{
            ...commonStyle,
            /* If your SVG uses currentColor internally, this will tint it: */
            color: color,
          }}
          aria-hidden="true"
          draggable="false"
        />
      )}

      {/* Screen-reader label (hidden) */}
      <span className={styles.srOnly}>{label}</span>

      {/* Optional visible text next to the spinner */}
      {children ? <span>{children}</span> : null}
    </span>
  );
}
